import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LayoutCell } from '../../../element-editor/store/studio/layout/layout-cell';

@Component({
  selector: 'nw-layout-cell',
  templateUrl: './layout-cell.component.html',
  styleUrls: ['./layout-cell.component.scss'],
})
export class LayoutCellComponent {
  @Input() node: LayoutCell;
  @Input() selectedNode: LayoutCell | null = null;
  @Output() nodeSelect = new EventEmitter<LayoutCell>();

  selectNode(node: LayoutCell) {
    this.nodeSelect.emit(node);
  }
}
